import SimpleTablePage from "../common/SimpleTablePage";

const columns = [
  { title: "ID", dataIndex: "id", key: "id", fixed: "left", width: 70 },
  { title: "Nome", dataIndex: "name", key: "name", ellipsis: true, width: 200 },
  {
    title: "Campi",
    dataIndex: "formItems",
    key: "formItems",
    width: 100,
    render: (items) => items?.length ?? 0,
  },
  {
    title: "Sezioni",
    dataIndex: "sections",
    key: "sections",
    width: 100,
    render: (sections) => sections?.length ?? 0,
  },
];

export default function PosModels() {
  return <SimpleTablePage resource="posModel" columns={columns} />;
}
